<!--
  --
  -- フォーム コンポーネント
  --
  -->
<template>
  <v-form
    :class="classes"
    ref="form"
    lazy-validation

    :value="value"
    @input="$emit('input', $event)"

    @submit.prevent="onSubmit"
  >
    <slot/>
  </v-form>
</template>

<script>
export default {
  name: 'CForm',

  // v-model を利用するための定義
  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    cardStyle: {
      type: Boolean,
      default: false
    },

    /**
     * v-form のバリデーション値
     */
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes () {
      const classes = []
      if (this.cardStyle) {
        classes.push(
          'v-card',
          'v-sheet',
          this.$vuetify.theme.isDark ? 'theme--dark' : 'theme--light'
        )
      }
      return classes
    }
  },

  methods: {
    /**
     * submit イベントの処理
     */
    onSubmit (event) {
      // 各入力コンポーネントの rules をチェックし、すべて合格しているか確認する
      if (!this.$refs.form.validate()) {
        return
      }

      // submit ボタンの value を取得する
      const value = event.submitter ? event.submitter.value : ''

      // 親コンポーネントに submit イベントを送信する
      this.$emit('submit', value)
    }
  }
}
</script>
